import {
    coverageSubmissionList,
    coverageSubmissionByID,
} from '@/services/agency/showcaseCoverageSubmissions.service'

export default {
    namespaced: true,
    state: {
        coverageSubmissionList: { meta: { pagination: { total: 0 } } },
        coverageSubmission: {},
        coverageSubmissionStatus: 'pending',
    },
    getters: {
        getCoverageSubmissionList(state) { return state.coverageSubmissionList },
        getCoverageSubmission(state) { return state.coverageSubmission },
        getCoverageSubmissionStatus(state) { return state.coverageSubmissionStatus },
    },
    mutations: {
        COVERAGE_SUBMISSION_LIST(state, value) { state.coverageSubmissionList = value },
        SET_COVERAGE_SUBMISSION(state, value) { state.coverageSubmission = value },
        COVERAGE_SUBMISSION_STATUS(state, value) { state.coverageSubmissionStatus = value },
    },
    actions: {
        async fetchCoverageSubmissionList({ commit }, params) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            commit('COVERAGE_SUBMISSION_STATUS', 'pending')
            commit('COVERAGE_SUBMISSION_LIST', { meta: { pagination: { total: 0 } } })
            try {
                const { data } = await coverageSubmissionList(params)
                commit('COVERAGE_SUBMISSION_STATUS', 'init')
                commit('COVERAGE_SUBMISSION_LIST', data)
                return data
            } catch (error) {
                commit('COVERAGE_SUBMISSION_STATUS', 'init')
                throw error
            }
        },
        async fetchCoverageSubmissionByID({ commit }, params) {
            commit('COVERAGE_SUBMISSION_STATUS', 'pending')
            try {
                const { data } = await coverageSubmissionByID(params)
                commit('COVERAGE_SUBMISSION_STATUS', 'init')
                commit('SET_COVERAGE_SUBMISSION', data.data)
                return data
            } catch (error) {
                commit('COVERAGE_SUBMISSION_STATUS', 'init')
                return error
            }
        },
    },
}
